module.exports = __webpack_public_path__ + "media/24 take one’s time.a8e3e415.mp3";